import { createSelector } from 'reselect';
import { CareRecommendationState } from 'src/generated/webapp_gql';

import {
    getWho5Score,
    getWho5ScoreFetched,
} from 'src/modules/assessments/selectors/assessmentsSelectors';
import { getGoalInterests } from 'src/modules/goals/selectors/goalsSelectors';
import { getMostRecentCareRecommendation } from 'src/modules/user/selectors/userSelectors';

export const isOnboardedInfoFetched = createSelector(
    getGoalInterests,
    getWho5ScoreFetched,
    (goalInterests, who5ScoreFetched) => goalInterests !== null && who5ScoreFetched,
);

export const getGoalInterestsSelected = createSelector(
    getGoalInterests,
    goalInterests =>
        Array.isArray(goalInterests?.oldGoalsAndInterests) &&
        !!goalInterests?.oldGoalsAndInterests.length,
);

export const isOnboardingFirstStepCompleted = createSelector(
    getGoalInterestsSelected,
    getMostRecentCareRecommendation,
    (goalInterestsSelected, careRecommendation) =>
        careRecommendation?.state === CareRecommendationState.BypassedAssessments ||
        !!goalInterestsSelected,
);

export const isOnboardingSecondStepCompleted = createSelector(
    getWho5ScoreFetched,
    getWho5Score,
    getMostRecentCareRecommendation,
    (who5ScoreFetched, who5Score, careRecommendation) =>
        careRecommendation?.state === CareRecommendationState.BypassedAssessments ||
        (who5ScoreFetched && who5Score >= 0),
);

export const isOnboardingCompleted = createSelector(
    isOnboardingFirstStepCompleted,
    isOnboardingSecondStepCompleted,
    (firstStepCompleted, secondStepCompleted) => firstStepCompleted && secondStepCompleted,
);
